import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonPage, IonSpinner, IonThumbnail, IonTitle, IonToolbar, useIonAlert } from "@ionic/react"
import React, { useRef, useState } from "react";
import { closeModal } from "../../services/redux/slices";
import { useAppDispatch, useAppSelector } from "../../services/redux/hook";
import { closeOutline } from "ionicons/icons";
import { Asset, DelegateSigningParams, WalletInfoState } from "../../types/types";
import MarketInfo from "../accounts-details/MarketInfo";
import { useTranslation } from "react-i18next";
import * as txBuilder from '../../services/stellar/TransactionBuilder';
import { createSep7URI } from "../../services/stellar/sep7";
import { Transaction } from "@stellar/stellar-sdk";
import {useDelegateSigningMutation } from "../../services/api/ebioro/ebioro";
import PaymentProcessing from "../payment-processing/PaymentProcessing";
import { store } from "../../services/redux/store";
import { Provider } from "react-redux";


const Page: React.FC = () => {
    const nav = document.querySelector("ion-nav");
    const { t, i18n } = useTranslation();
    const pageRef = useRef();
    const dispatch = useAppDispatch();
    const [isSpinner, setIsSpinner] = useState(false);
    const asset: Asset = useAppSelector((state) => state.selectedAsset);
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    const [delegateSigning, result] = useDelegateSigningMutation();
    const [disableButton,setDisableButton] = useState(false);
    const close = () => {

        dispatch(closeModal());

    }

    const [present] = useIonAlert();

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const addAccount = async () => {

        try {

            setIsSpinner(true);

            if (walletInfo.has_key) {

                const assetAndIssuer = asset.identifier.split(':')
                const assetCode = assetAndIssuer[0];
                const assetIssuer = assetAndIssuer[1];

                const [trustError, transaction] = await txBuilder.createTrust(assetCode, assetIssuer, walletInfo.account_key as string, walletInfo.device_private_key as string);

                if (trustError) {
                    presentErrorAlert({ data: JSON.stringify(trustError) })
                    return
                }

                const uri = createSep7URI(transaction as Transaction,walletInfo.account_key as string);

                if (!uri) {

                    presentErrorAlert({ data: 'No valid uri creation' })
                    return

                }

                let params: DelegateSigningParams = {
                    uri: uri,
                    account: walletInfo.account_key as string,
                    asset_code: asset.display_code,
                    asset_issuer: asset.identifier.split(':')[1],
                    msg:'Account creation'
                }

                const response = await delegateSigning(params).unwrap();
                
                const stellarTxId = response.stellar_transaction_id as string;
                const textMessage = `${t('account.message.ADD_ASSET_1')} ${asset.code} ${t('account.message.ADD_ASSET_2')}`

                nav?.push(() =><PaymentProcessing transactionId={stellarTxId} messageText={textMessage} successMessage={t('account.creation.LABEL') as string}/>)

            }

        } catch (error) {
        
            presentErrorAlert({ data: t('application.uncaught.ERROR') })
            
        } finally{
            setIsSpinner(false);
            setDisableButton(true)
        }

    }

    return (
        <IonPage ref={pageRef}>
            <IonHeader className="ion-no-border">
                <IonToolbar >
                    <IonButtons slot="start">
                        <IonButton onClick={() => { close() }} color='primary'>
                            <IonIcon slot="icon-only" icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle className="ion-text-center"> {asset.name} </IonTitle>
                    <IonItem lines="none" slot="primary" className="accountDetailsPageHeaderItem"

                    >
                        <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start">
                            <img src={asset.icon} />
                        </IonThumbnail>
                    </IonItem>

                </IonToolbar>

            </IonHeader>
            <IonContent>

                <MarketInfo asset={asset} />

            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        color='primary'
                        onClick={() => {addAccount() }}
                        disabled={disableButton}
                        type="submit"
                        expand="block"
                        id='pageFooterButton'>
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            : `${t('account.add.TRUST-BTN')} ${asset.code}`}
                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    )

}

const AddAccountPage: React.FC = () => (
    <Provider store={store}>
      <Page />
    </Provider>
  );
  
  export default AddAccountPage;